/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsPlayerChampionPlayDtoSchema = z.object({
  championName: z.string().nullish(),
  games: z.optional(z.int()),
});
